import 'css-chunksrc/client/scenes/zoneEdition/zoneEditionForm/styles.scss';export default {
  "zoneEditionForm": "_zoneEditionForm_cslen_1",
  "formGroup": "_formGroup_cslen_5",
  "name": "_name_cslen_9",
  "zoneAvatar": "_zoneAvatar_cslen_22",
  "description": "_description_cslen_32",
  "title": "_title_cslen_39",
  "textArea": "_textArea_cslen_44"
};